export default function PHP_fnmatch() {
  return (
    <div>
      <h1>PHP_fnmatch</h1>
    </div>
  );
}
